/**
 * Get seconds diff between two dates
 * @param {Date} d1 
 * @param {Date} d2 
 */
export function secondsDiff(d1, d2) {
  let secDiff = Math.floor((d2 - d1) / 1000);
  return secDiff;
}
/**
 * Return seconds difference between 2 dates disregarding miliseconds
 * This will return seconds difference with precision until seconds
 * @param {Date} d1 Date to subtract
 * @param {Date} d2 Date to subtract from
 */
export function secondsDiffNoMil(d1, d2) {
  let secDiff = Math.floor(d2 / 1000) - Math.floor(d1 / 1000);
  return secDiff;
}

/**
 * Get minutes diff between two dates
 * @param {Date} d1 
 * @param {Date} d2 
 */
export function minutesDiff(d1, d2) {
  let seconds = secondsDiff(d1, d2);
  let minutesDiff = Math.floor(seconds / 60);
  return minutesDiff;
}

/**
 * Get hours diff between two dates
 * @param {Date} d1 
 * @param {Date} d2 
 */
export function hoursDiff(d1, d2) {
  let minutes = minutesDiff(d1, d2);
  let hoursDiff = Math.floor(minutes / 60);
  return hoursDiff;
}

/**
 * Get days diff between two dates
 * @param {Date} d1 
 * @param {Date} d2 
 */
export function daysDiff(d1, d2) {
  let hours = hoursDiff(d1, d2);
  let daysDiff = Math.floor(hours / 24);
  return daysDiff;
}

/**
 * Get weeks diff between two dates
 * @param {Date} d1 
 * @param {Date} d2 
 */
export function weeksDiff(d1, d2) {
  let days = daysDiff(d1, d2);
  let weeksDiff = Math.floor(days / 7);
  return weeksDiff;
}

/**
 * Get years diff between two dates
 * @param {Date} d1 
 * @param {Date} d2 
 */
export function yearsDiff(d1, d2) {
  let date1 = new Date(d1);
  let date2 = new Date(d2);
  let yearsDiff = date2.getFullYear() - date1.getFullYear();
  return yearsDiff;
}

/**
 * Get months diff between two dates
 * @param {Date} d1 
 * @param {Date} d2 
 */
export function monthsDiff(d1, d2) {
  let date1 = new Date(d1);
  let date2 = new Date(d2);
  let years = yearsDiff(d1, d2);
  let months = (years * 12) + (date2.getMonth() - date1.getMonth());
  return months;
}
